import React, { useCallback, useEffect, useRef, useState } from "react";
import MatchingPlayer from "./MatchingPlayer";
import { UserDetailsKey, getDataFromStore } from "../utils/DataStore";
import { BackIcon } from "./common/SvgComponents";
import { useCountdown } from "../utils/useCountdown";

const Matching = ({ entryFee, playerCount, tableModel, matchingScreenDetails, unJoinTemplatePool }) => {

    const [timeRemaining, setTimeRemaining] = useState(60)
    const [isRunning, setIsRunning] = useState(false)
    const intervalRef = useRef(null)
    // const { timeRemaining, isRunning, start, pause, reset } = useCountdown(initialTime);

    useEffect(() => {
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
            }
        }
    }, [])
    const start = useCallback(() => {
        if (!isRunning && timeRemaining > 0) {
            setIsRunning(true)
            intervalRef.current = setInterval(() => {
                setTimeRemaining((prevTime) => {
                    if (prevTime <= 1) {
                        clearInterval(intervalRef.current)
                        setIsRunning(false)
                        return 0
                    }
                    return prevTime - 1
                })
            }, 1000)
        }
    }, [isRunning, timeRemaining])

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60)
        const seconds = time % 60
        return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
    }

    useEffect(() => {
        if (matchingScreenDetails?.responsePacket?.template.kickedTimeStamp) {
            let kickedTimeStamp = matchingScreenDetails?.responsePacket?.template.kickedTimeStamp
            let now = new Date().getTime();
            let remainingTimestamp = Math.floor((kickedTimeStamp - now) / 1000);

            handleInitialTimeChange(remainingTimestamp)
        }
    }, [matchingScreenDetails?.nextNumber])


    const handleInitialTimeChange = (e) => {
        const newTime = Number.parseInt(e, 10)
        if (!isNaN(newTime) && newTime >= 0) {
            setTimeRemaining(newTime);
            clearInterval(intervalRef.current);
            start();
            // start()
        }
    }

    const [userDetail] = useState(getDataFromStore(UserDetailsKey));
    const [matchingPlayerList, setMatchingPlayerList] = useState([]);
    useEffect(() => {
        let players = [];
        if (tableModel?.chairs) {
            tableModel.chairs.map((chair, index) => {
                if (chair.playerModel !== null && chair.playerModel !== undefined) {
                    if (chair.playerModel.playerId !== userDetail.playerId) {
                        players.push(chair.playerModel);
                    }
                }
            });
        }
        setMatchingPlayerList(players);
    }, [tableModel]);

    return (
        <>
            <div className="matching-body">
                <div>
                    <div className="py-2 px-3">
                        <span className="back-btn" onClick={() => unJoinTemplatePool()}>
                            <BackIcon />
                        </span>
                    </div>
                    <div className="text-center">
                        <img src={`/assets/img/asset_${process.env.REACT_APP_GAME_ASSET}/logo.jpg`} alt="" style={{ width: "97px", marginTop: "-35px" }} />
                        {/* <h5 className=' font-size-24 text-white'>Classic Ludo</h5> */}

                    </div>
                </div>
                <h6 className="text-center text-white fs-12 fw-500 mb-0 mt-4">Mutual fund investments are subject to market risks, read<br />all scheme related documents carefully.</h6>
                <div className="d-flex align-items-center justify-content-center" style={{ flex: "1" }}>
                    <div className="matching-player">
                        {Array.from(Array(playerCount - 1), (_, i) => (
                            <div key={i} className={`player-${i + 1} px-2 ${matchingPlayerList.length > 0 && "PlayerActive"}`}>
                                {matchingPlayerList.length === 0 ? (
                                    <MatchingPlayer />
                                ) : (
                                    <MatchingPlayer playreAvatar={matchingPlayerList[i].avatar} playerName={matchingPlayerList[i].playerName} entryFee={entryFee} />
                                )}
                            </div>
                        ))}
                        <div className="player-4 px-2 PlayerActive">
                            <MatchingPlayer playreAvatar={userDetail.photoImageUrl} playerName={userDetail.playerName} entryFee={entryFee} />
                        </div>
                        <img className="vs-img" src={`/assets/img/asset_${process.env.REACT_APP_GAME_ASSET}/vs-img.png`} alt="" />
                    </div>
                </div>
                <h6 className="digital-no">{formatTime(timeRemaining)}</h6>

                {/* <h6 className="digital-no">{formatTime(timeRemaining)}</h6> */}
                <div className="text-center text-white pb-3 pt-3 px-3">
                    <div className="bottomText p-2">
                        <h3>The game will begin shortly....</h3>
                    </div>
                    {/* <h5 className="mt-3">
                        Entry fee will be refunded if all players
                        <br /> do not join the game
                    </h5> */}
                </div>
            </div>
        </>
    );
};

export default Matching;
